import { useQuery } from "@tanstack/react-query";
import { useAuth } from "./useAuth";

export function useGaContext() {
  const { user } = useAuth();

  // GA ID comes from the user's gaId field, or from the first GA profile they belong to
  const gaId = (user as any)?.gaId || "demo-ga-1";

  const { data: gaProfile } = useQuery<any>({
    queryKey: ["/api/ga", gaId, "profile"],
    queryFn: async () => {
      const res = await fetch(`/api/ga/${gaId}/profile`);
      if (!res.ok) return null;
      return res.json();
    },
    enabled: !!gaId,
  });

  return {
    gaId,
    gaProfile,
    gaName: gaProfile?.name || "GA Portal",
  };
}
